import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, AutoComplete, Button, Col, Divider, Form, Input, Row, Select } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/InfoDevice/InfoDeviceModel';
import InfoDeviceService from '../../../services/infoDevice/InfoDeviceService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const { Option } = Select;

const InfoDeviceForm: React.FC<any> = ({}) => {
  const [form] = useForm();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();
  const dispatch = useDispatch();
  const width = useWindowSize();

  const deviceTypes = useSelector((state: RootState) => state.store.deviceType.data || []);
  const infoDevice = useSelector((state: RootState) => state.models.infoDevice);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.infoDevice?.id),
    name: useSelector((state: RootState) => state?.models?.infoDevice?.name),
    deviceTypeId: useSelector((state: RootState) => state?.models?.infoDevice?.deviceTypeId),
    deviceType: useSelector((state: RootState) => state?.models?.infoDevice?.deviceType),

    model: useSelector((state: RootState) => state?.models?.infoDevice?.model),
    pieces: useSelector((state: RootState) => state?.models?.infoDevice?.pieces),
  };

  const handleSelect = (value: string) => {
    const deviceType = deviceTypes?.find((sc) => sc.name === value);
    const fieldsValue = {
      ...form.getFieldsValue(true),
      deviceTypeId: deviceType?.id,
      deviceType: deviceType,
    };

    form.setFieldsValue(fieldsValue);
    dispatch(updateField({ field: 'deviceTypeId', value: deviceType.id }));
    dispatch(updateField({ field: 'deviceType', value: deviceType }));
  };

  const onSaveInfoDeviceType = async () => {
    saveInfoDeviceType(infoDevice);
  };

  const { mutate: saveInfoDeviceType, isPending: _isSavingInfoDevice } = useMutation({
    mutationFn: (formData: any) => InfoDeviceService.upsert(infoDevice.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !infoDevice.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  const handleFilter = (inputValue: string, option: any) => {
    return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1;
  };

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  useEffect(() => {
    form.setFieldsValue(infoDevice);
  }, [infoDevice]);

  return (
    <Form
      form={form}
      name='infoDeviceForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      onFinish={onSaveInfoDeviceType}
      layout='vertical'
    >
      <Divider />
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item
            label='Tip de device'
            name={['deviceType', 'name']}
            rules={[{ required: true, message: 'Introdu tipul de device!' }]}
          >
            <AutoComplete onSelect={handleSelect} filterOption={handleFilter}>
              {deviceTypes?.map((item: any) => (
                <Option key={item.id} value={item.name}>
                  {item.name}
                </Option>
              ))}
            </AutoComplete>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={12} md={8} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Model' name='model' rules={[{ required: true, message: 'Introdu model!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} className={`col ${width > 700 ? 'col-wide' : 'col-narrow'}`}>
          <Form.Item label='Pieces' name='pieces' rules={[{ required: true, message: 'Introdu numarul de piese!' }]}>
            <Input type='number' />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default InfoDeviceForm;
